import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function SalesNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentNotification, setCurrentNotification] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  const notifications = [{
    name: 'Carlos M.',
    location: 'Madrid, España',
    action: 'acaba de comprar Viral Video Machine IA',
    price: '$27',
    time: 'Hace 2 minutos'
  }, {
    name: 'María G.',
    location: 'Buenos Aires, Argentina',
    action: 'se unió a Viral Video Machine IA',
    price: '$27',
    time: 'Hace 5 minutos'
  }, {
    name: 'Juan P.',
    location: 'Ciudad de México',
    action: 'acaba de comprar Viral Video Machine IA',
    price: '$27',
    time: 'Hace 8 minutos'
  }, {
    name: 'Ana R.',
    location: 'Bogotá, Colombia',
    action: 'se unió a Viral Video Machine IA',
    price: '$27',
    time: 'Hace 12 minutos'
  }, {
    name: 'Luis F.',
    location: 'Lima, Perú',
    action: 'acaba de comprar Viral Video Machine IA',
    price: '$27',
    time: 'Hace 15 minutos'
  }];
  useEffect(() => {
    if (isDismissed) return;
    const showNotification = () => {
      setCurrentNotification(Math.floor(Math.random() * notifications.length));
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const interval = setInterval(() => {
      showNotification();
    }, 8000);
    setTimeout(() => {
      showNotification();
    }, 3000);
    return () => clearInterval(interval);
  }, [isDismissed]);
  const handleDismiss = () => {
    setIsVisible(false);
    setTimeout(() => {
      setIsDismissed(true);
    }, 500);
  };
  if (isDismissed) return null;
  const notification = notifications[currentNotification];
  return <div className={`fixed bottom-4 left-4 right-4 md:left-4 md:right-auto z-50 transition-all duration-500 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8 pointer-events-none'}`} data-id="element-305">
      <div className="bg-white/95 backdrop-blur-xl rounded-xl shadow-2xl border border-gray-200/50 p-3 md:p-4 w-full md:max-w-md" data-id="element-306">
        <div className="flex items-center gap-3 relative" data-id="element-307">
          <button onClick={handleDismiss} className="absolute -top-2 -right-2 p-1.5 bg-gray-100 hover:bg-gray-200 rounded-full transition-colors z-10 shadow-md" aria-label="Cerrar notificación" data-id="element-308">
            <XIcon className="w-4 h-4 text-gray-600" data-id="element-309" />
          </button>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8uwCuZjZCdHsneymtA2ypT/VVM.png" alt="Viral Video Machine" className="w-16 h-16 md:w-20 md:h-20 rounded-lg object-cover flex-shrink-0 shadow-sm" data-id="element-310" />
          <div className="flex-1 min-w-0 flex flex-col justify-center pr-6" data-id="element-311">
            <p className="text-sm md:text-base font-semibold text-gray-900 truncate leading-tight mb-1" data-id="element-312">
              {notification.name}
            </p>
            <p className="text-xs md:text-sm text-gray-600 line-clamp-2 leading-snug mb-1" data-id="element-313">
              {notification.action}
            </p>
            <div className="flex items-center gap-2 flex-wrap" data-id="element-314">
              <p className="text-xs md:text-sm font-semibold text-purple-600 leading-tight" data-id="element-315">
                {notification.price}
              </p>
              <span className="text-xs text-gray-500 leading-tight" data-id="element-316">
                • {notification.time}
              </span>
            </div>
          </div>
          <CheckCircle2Icon className="w-6 h-6 md:w-7 md:h-7 text-green-500 flex-shrink-0" data-id="element-317" />
        </div>
      </div>
    </div>;
}